import { useEffect, useState } from "react";
import Pagination from "../Config/Pagination";
import { Select, DatePicker } from "antd";
import { API_BASE_URL } from "../Config/Config";
import { FooterComponent } from "../Config/footer";
import { HeaderComponent } from "../Config/header";
import { useNavigate } from "react-router-dom";
import dayjs from "dayjs";
const { RangePicker } = DatePicker;

export function AttendenceComponent() {
  const navigate = useNavigate();
  const today = dayjs();
  const tenDaysBefore = today.subtract(10, "day");
  const userData =
    JSON.parse(localStorage.getItem("userData")) ||
    JSON.parse(sessionStorage.getItem("userData"));
  const regId = userData?.RegId;

  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 10;
  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const paginate = (pageNumber) => setCurrentPage(pageNumber);

  const [storedUserData, setStoredUserData] = useState([]);
  const [attendanceData, setAttendanceData] = useState([]);
  const [dataLoading, setDataLoading] = useState(false);
  const [tokenData, setTokenData] = useState(null);
  const [superIdData, setSuperIdData] = useState(null);
  const [startDate, setStartDate] = useState(
    tenDaysBefore.format("YYYY-MM-DD")
  );
  const [endDate, setEndDate] = useState(today.format("YYYY-MM-DD"));

  useEffect(() => {
    const userDataString =
      localStorage.getItem("userData") || sessionStorage.getItem("userData");
    if (userDataString) {
      const userData = JSON.parse(userDataString);
      setStoredUserData(userData);
    } else {
      console.log("User data not found in localStorage");
    }
  }, []);

  const disabledDate = (current) => {
    return current && current > today.endOf("day");
  };

  const handleStartChange = (date) => {
    setStartDate(date ? date.format("YYYY-MM-DD") : null);
  };

  const handleEndChange = (date) => {
    setEndDate(date ? date.format("YYYY-MM-DD") : null);
  };

  useEffect(() => {
    const token =
      localStorage.getItem("authToken") || sessionStorage.getItem("authToken");
    const superId =
      localStorage.getItem("superId") || sessionStorage.getItem("superId");

    if (token && superId) {
      setTokenData(token);
      setSuperIdData(superId);
    } else {
      console.warn("User data not found");
      navigate("/");
    }
  }, [navigate]);

  const fetchAttendance = () => {
    if (tokenData && superIdData) {
      setDataLoading(true);

      fetch(
        `${API_BASE_URL}Attendance/getempattendance?regid=${regId}&superid=${superIdData}&fromdate=${startDate}&todate=${endDate}`,
        {
          method: "GET",
          headers: { Authorization: `Bearer ${tokenData}` },
        }
      )
        .then((response) => {
          if (!response.ok)
            throw new Error(`HTTP error! Status: ${response.status}`);
          return response.json();
        })
        .then((data) => {
          if (data?.status) {
            setAttendanceData(data.ResultData || []);
          } else {
            console.error("Invalid data format:", data);
            setAttendanceData([]);
          }
        })
        .catch((error) => {
          console.error("Error fetching data:", error);
        })
        .finally(() => {
          setDataLoading(false);
        });
    }
  };

  useEffect(() => {
    fetchAttendance(); // Initial fetch
  }, [superIdData, tokenData]);
  const currentItems = attendanceData.slice(indexOfFirstItem, indexOfLastItem);

  const formatTimeHHMM = (value) => {
    if (!value) return "-";

    const date = new Date(value);
    if (isNaN(date)) return "-";

    const hours = String(date.getUTCHours()).padStart(2, "0");
    const minutes = String(date.getUTCMinutes()).padStart(2, "0");

    return `${hours}:${minutes}`;
  };

  return (
    <>
      <HeaderComponent></HeaderComponent>
      <div className="d-flex flex-column flex-root">
        <div className="page d-flex flex-row flex-column-fluid">
          <div
            className="wrapper d-flex flex-column flex-row-fluid"
            id="kt_wrapper"
          >
            <div className="toolbar " id="kt_toolbar">
              <div
                id="kt_toolbar_container"
                className="container-xxl d-flex flex-stack flex-wrap"
              >
                <div className="page-title d-flex flex-column">
                  <h1 className="page-heading d-flex flex-column justify-content-center text-gray-900 fw-bolder fs-3 m-0">
                    Attendance
                  </h1>
                </div>
              </div>
            </div>
            <div
              id="kt_content_container"
              className="d-flex flex-column-fluid align-items-start container-xxl"
              style={{ marginBottom: "90px" }}
            >
              <div className="content flex-row-fluid pt-1" id="kt_content">
                <div className="card">
                  <div className="card-header p-0 justify-content-evenly">
                    <div className="card-title px-2">
                      <form className="d-flex row justify-content-between align-items-end">
                        <div className="col-5">
                          <p className="text-start mb-1 text-muted fw-semibold">
                            Start Date
                          </p>
                          <DatePicker
                            defaultValue={tenDaysBefore}
                            onChange={handleStartChange}
                            disabledDate={disabledDate}
                          />
                        </div>
                        <div className="col-5">
                          <p className="text-start mb-1 text-muted fw-semibold">
                            End Date
                          </p>
                          <DatePicker
                            defaultValue={today}
                            onChange={handleEndChange}
                            disabledDate={disabledDate}
                          />
                        </div>
                        <div className="col-2">
                          <button
                            className="btn btn-primary btn-sm"
                            onClick={fetchAttendance}
                          >
                            <i className="fa-solid fa-magnifying-glass"></i>
                          </button>
                        </div>
                      </form>
                    </div>
                  </div>
                  <div className="card-body p-0">
                    <div className="table-responsive">
                      <table
                        className="table align-middle table-row-dashed fs-6 gy-5"
                        id="kt_customers_table"
                      >
                        <tbody className="text-start fw-semibold text-gray-600">
                          {dataLoading ? (
                            <tr>
                              <td colSpan={7}>
                                <p className="loader text-center">loading...</p>
                              </td>
                            </tr>
                          ) : currentItems.length > 0 ? (
                            currentItems.map((item, index) => (
                              <div className="card card border border-secondary my-3 mx-5">
                                <div className="card-header d-flex justify-content-between align-items-center p-2 ">
                                  <div className="d-flex">
                                    <p className="m-0 text-muted fw-semibold">
                                      Date:
                                    </p>
                                    <p className="m-0 text-dark">
                                      {item.Date ? item.Date : "N/A"}
                                    </p>
                                  </div>
                                  <div className="d-flex">
                                    <p className="m-0 text-muted fw-semibold">
                                      Shift:
                                    </p>
                                    <p className="m-0 text-dark">
                                      {item.ActualShift
                                        ? item.ActualShift
                                        : "N/A"}
                                    </p>
                                  </div>
                                  <div className="">
                                    <span
                                      className={
                                        item.Status === "Present"
                                          ? "badge-success fw-semibold badge p-2"
                                          : item.Status === "Leave"
                                          ? "badge-danger fw-semibold badge p-2"
                                          : item.Status === "Late"
                                          ? "badge-info fw-semibold badge p-2"
                                          : item.Status === "No Swipe"
                                          ? "badge-warning fw-semibold badge p-2"
                                          : item.Status === "Week Off"
                                          ? "badge-primary fw-semibold badge p-2"
                                          : item.Status === "Missed Swipe"
                                          ? "badge-primary fw-semibold badge p-2"
                                          : ""
                                      }
                                    >
                                      {item.Status}
                                    </span>
                                  </div>
                                  <div className="d-flex  align-items-center w-100 row">
                                    <div className=" my-1 col-5 d-flex">
                                      <p className="m-0 text-muted fw-semibold">
                                        IN:
                                      </p>
                                      <p className="m-0 text-dark">
                                        {item.InTime
                                          ? formatTimeHHMM(item.InTime)
                                          : "N/A"}
                                      </p>
                                    </div>
                                    <div className="my-1 col-7 d-flex">
                                      <p className="m-0 text-muted fw-semibold ms-5">
                                        OUT:
                                      </p>
                                      <p className="m-0 text-dark">
                                        {item.OutTime
                                          ? formatTimeHHMM(item.OutTime)
                                          : "N/A"}
                                      </p>
                                    </div>
                                  </div>
                                </div>

                                <div className="card-body p-2 d-flex">
                                  <p className="m-0 text-muted fw-semibold">
                                    Duration:
                                  </p>
                                  <p className="text-dark">
                                    {" "}
                                    {item.Duration ? item.Duration : "N/A"}
                                  </p>
                                </div>
                              </div>
                            ))
                          ) : (
                            <tr>
                              <td colSpan={7} className="text-center">
                                No attendance data available for the selected
                                year and month.
                              </td>
                            </tr>
                          )}
                        </tbody>
                      </table>
                    </div>

                    <Pagination
                      itemsPerPage={itemsPerPage}
                      totalItems={attendanceData.length}
                      paginate={paginate}
                      currentPage={currentPage}
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <FooterComponent> </FooterComponent>
    </>
  );
}
